import Render from '@Views/root/patients/patient/pediatrics/read-only-neonatal.html'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IPediatrics } from '@Store/types'

@Render
@Component({})
export class ReadOnlyNeonatal extends Vue {

	@Prop() pediatrics: IPediatrics
}